import FloatingShapes from '../libs/floating-shapes';

export default {
    init() {
        FloatingShapes.init();
    },
    finalize() {
    },
};
